import React, { useState, useEffect } from "react";
import edMantra from "../../services/edMantra";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import moment from "moment"; // Import moment library for date formatting

import ErrorPopup from "../Errors/ErrorPopup"; // Import ErrorPopup component

const MarketingAddLead = ({ handleClose }) => {
  const [assignee, setAssignee] = useState([]);
  const [lead, setLead] = useState({ telecaller: "select", source: "" });
  const [errors, setErrors] = useState({});
  const [selectedSource, setSelectedSource] = useState("");
  const [marketingExecutive, setMarketingExecutive] = useState([]);
  const [marketingManager, setMarketingManager] = useState([]);
  const [vendorManagementExecutive, setVendorManagementExecutive] = useState([]);
  const [vendorManagementManager, setVendorManagementManager ] = useState([]);
   const [allEmployees, setAllEmployees] = useState([]);
  // Handle nextfollow separately
  const [selectedDate, setSelectedDate] = useState(null);
 

  const handleLead = async () => {
    try {
      const validationErrors = validateForm(lead);
      if (Object.keys(validationErrors).length === 0) {
        // Form is valid, proceed with submitting data
        const leadData = {
          ...lead,
        };
        const result = await edMantra.addMarketingLeads(leadData);

        if (result.status === 201) {
          // Successful response
          toast(result?.data?.message);
          setLead({});
          handleClose(false);
        } else {
          // Error response
          console.log("Response status code:", result.status);
          let errorMessage = "Please check";
          if (result?.data?.error) {
            errorMessage = result.data.error;
          }
          toast.error(errorMessage);
        }
      } else {
        // Set validation errors
        setErrors(validationErrors);
        Object.keys(validationErrors).forEach((key) => {
          toast.error(validationErrors[key]);
        });
      }
    } catch (error) {
      // Handle errors that are not related to the server response status
      if (error.response && error.response.data && error.response.data.error) {
        toast.error(error.response.data.error);
      } else {
        console.error("An error occurred:", error);
        toast.error(
          "An error occurred while submitting the form. Please try again."
        );
      }
    }
  };

   const getAllEmployees = async () => {
      try {
        const allEmployees = await edMantra.getAllEmployees();
        setAllEmployees(allEmployees.data.data);
      } catch (err) {
        console.error(err, "Error fetching data");
      }
    };

  const getAllMarketingExecutive = async () => {
    const result = await edMantra.getAllMarketingExecutive();
    setMarketingExecutive(result?.data?.data);
  };
  const getAllMarketingManager = async () => {
    const result = await edMantra.getAllMarketingManager();
    setMarketingManager(result?.data?.data);
  };

  const getAllVendorManagementExecutive = async () => {
    const result = await edMantra.getAllVendorManagementExecutive();
    setVendorManagementExecutive(result?.data?.data);
  };

  const getAllVendorManagementManager = async () => {
    const result = await edMantra.getAllVendorManagementManager();
    setVendorManagementManager(result?.data?.data);
  };

  
  const validateForm = (data) => {
    let errors = {};
    if (!/^[a-zA-Z\s]+$/.test(data.clientName)) {
      errors.clientName = "Only Characte is allowed in Name";
    }

    if (!/^\d{10}$/.test(data.pocMobile)) {
      errors.pocMobile = "First Phone number must be exactly 10 digits long";
    }

    if (!/\S+@\S+\.\S+/.test(data.pocEmail)) {
      errors.pocEmail = "Email address is invalid";
    }

    if (!/^[a-zA-Z\s]+$/.test(data.pocDesignation)) {
      errors.pocDesignation = "Only Characte is allowed in  Designation";
    }
    if (!/^[a-zA-Z\s]+$/.test(data.decisionMaker)) {
      errors.decisionMaker = "Only Characte is allowed in Decision Maker";
    }

    if (!/^\d{10}$/.test(data.dmMobile)) {
      errors.dmMobile = "Second Phone number must be exactly 10 digits long";
    }

    if (!/^[a-zA-Z\s]+$/.test(data.dmDesignation)) {
      errors.dmDesignation = "Only Characte is allowed in Designation";
    }

    // if (!/^[a-zA-Z\d\s,]+$/.test(data.address)) {
    //   errors.address = "Address can only contain letters, numbers, spaces, and commas.";
    // }
    
    

    if (!/^[a-zA-Z\d\s,]+$/.test(data.location)) {
      errors.location = "Location must contain both letters and numbers only.";
    }
    

    if (data.nextfollow === null) {
      errors.nextfollow = "You cannot leave the next follow-up date blank";
    }

    return errors;
  };

  //------------------validations-------------------------------
  const handleOnchange = (e) => {
    const { name, value } = e.target;

    setLead((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "lead.source") {
      setSelectedSource(value);
    }
  };

  useEffect(() => {
    getAllEmployees();
    getAllMarketingManager();
    getAllMarketingExecutive();
    getAllVendorManagementExecutive();
    getAllVendorManagementManager();
  }, []);

  useEffect(() => {
    console.log("Selected Source:", selectedSource);
  }, [selectedSource]);

  useEffect(() => {
    console.log("Lead State:", lead);
  }, [lead]);

  return (
    <div className="mt-lg-5">
      {/* Add ErrorPopup component here */}
      {Object.keys(errors).length > 0 && <ErrorPopup errors={errors} />}

      <div className="row">
        <div className="col-md-12">
          <h5>Add Marketing Lead</h5>
        </div>
      </div>
      <hr class="my-4 border border-dark"></hr>
      <div className="row">
        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Client/College Name:</label>
            <input
              type="text"
              placeholder="Name of the College or Client"
              className="form-control"
              value={lead.clientName}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  clientName: e.target.value,
                }))
              }
            />
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Category of Client/College:</label>
            <select
              className="form-control"
              value={lead.collegeCategory}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  collegeCategory: e.target.value,
                }))
              }
            >
              <option value="">Select Category</option>
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
              <option value="D">D</option>
            </select>
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Brief about Client/College:</label>
            <input
              type="text"
              placeholder="Name of the College or Client"
              className="form-control"
              value={lead.brief}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  brief: e.target.value,
                }))
              }
            />
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Point of Contact:</label>
            <input
              type="text"
              placeholder="Name of Primary Contact Person"
              className="form-control"
              value={lead.pocName}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  pocName: e.target.value,
                }))
              }
            />
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Mobile Number:</label>
            <input
              type="text"
              placeholder="Number of Primary Contact Person"
              className="form-control"
              value={lead.pocMobile}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  pocMobile: e.target.value,
                }))
              }
            />
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Email:</label>
            <input
              type="text"
              placeholder="Email of Primary Contact Person"
              className="form-control"
              value={lead.pocEmail}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  pocEmail: e.target.value,
                }))
              }
            />
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Designation:</label>
            <input
              type="text"
              placeholder="Designation of Primary Contact Person"
              className="form-control"
              value={lead.pocDesignation}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  pocDesignation: e.target.value,
                }))
              }
            />
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Address:</label>
            <input
              type="text"
              placeholder="Address of the College/Client"
              className="form-control"
              value={lead.address}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  address: e.target.value,
                }))
              }
            />
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Location:</label>
            <input
              type="text"
              placeholder="Location of the College/Client"
              className="form-control"
              value={lead.location}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  location: e.target.value,
                }))
              }
            />
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Objective:</label>
            <select
              className="form-control"
              value={lead.objective}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  objective: e.target.value,
                }))
              }
            >
              <option value="NA">Select Objective</option>
              <option value="Workshop">Workshop</option>
              <option value="Seminar">Seminar</option>
              <option value="LMS only">LMS only</option>
              <option value="LMS Hybrid">LMS Hybrid</option>
              <option value="Corporate Training">Corporate Training</option>
              <option value="Job Fair">Job Fair</option>
              <option value="Webinar">Webinar</option>
              <option value="Event">Event</option>
              <option value="Recruitment">Recruitment</option>
              <option value="Other">Other</option>
            </select>

            {/* Show input field when 'Other' is selected */}
            {lead.objective === "Other" && (
              <input
                type="text"
                className="form-control mt-2"
                placeholder="Please specify"
                value={lead.otherObjective || ""}
                onChange={(e) =>
                  setLead((prevState) => ({
                    ...prevState,
                    otherObjective: e.target.value,
                  }))
                }
              />
            )}
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Intrest Level:</label>
            <select
              className="form-control"
              value={lead.interestLevel}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  interestLevel: e.target.value,
                }))
              }
            >
              <option value="NA">Select Intrest Level</option>
              <option value="High">High</option>
              <option value="Medium">Medium</option>
              <option value="Low only">Low</option>
            </select>
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Status:</label>
            <select
              className="form-control"
              value={lead.status}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  status: e.target.value,
                }))
              }
            >
              <option value="NA">Select Status</option>
              <option value="Approached">Approached</option>
              <option value="Proposal Sent">Proposal Sent</option>
              <option value="Meeting Done">Meeting Done</option>
              <option value="Meeting Cancelled">Meeting Cancelled</option>
              <option value="Meeting Pending">Meeting Pending</option>
              <option value="Agreement Done">Agreement Done</option>
              <option value="LMS Purchased">LMS Purchased</option>
              <option value="Need Discussion">Need Discussion</option>
              <option value="Proposal Rejected">Proposal Rejected</option>
              <option value="Renewal Required">Renewal Required</option>
              <option value="Deal Closed">Deal Closed</option>
              <option value="Workshop/Seminar Proposed">
                Workshop/Seminar Proposed
              </option>
              <option value="Under Process">Under Process</option>
            </select>
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Source:</label>
            <select
              className="form-control"
              value={lead.source}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  source: e.target.value,
                }))
              }
            >
              <option value="">Select Source</option>
              <option value="Just Dial">Just Dial</option>
              <option value="Walk-in">Walk-in</option>
              <option value="Google Search">Google Search</option>
              <option value="Instagram">Instagram</option>
              <option value="Facebook">Facebook</option>
              <option value="Reference">Reference</option>
              <option value="Data Scraper Tool">Data Scraper Tool</option>
              <option value="Purchased Data">Purchased Data</option>
              <option value="Paid Ads">Paid Ads</option>
              <option value="Event/Activity">Event/Activity</option>
              <option value="Linkedin">Linkedin</option>
              <option value="Job Portals">Job Portals</option>
              <option value="Self Data">Self Data</option>
              <option value="Other">Other</option>
            </select>

            {/* Show input field when 'Other' is selected */}
            {lead.source === "Other" && (
              <input
                type="text"
                className="form-control mt-2"
                placeholder="Please specify"
                value={lead.otherSource || ""}
                onChange={(e) =>
                  setLead((prevState) => ({
                    ...prevState,
                    otherSource: e.target.value,
                  }))
                }
              />
            )}
            {lead.source === "Reference" && (
              <>
                <input
                  type="text"
                  className="form-control mt-2"
                  placeholder="Name of the Reference"
                  value={lead.refSourceName || ""}
                  onChange={(e) =>
                    setLead((prevState) => ({
                      ...prevState,
                      refSourceName: e.target.value,
                    }))
                  }
                />

                <input
                  type="text"
                  className="form-control mt-2"
                  placeholder="Contact of the Reference"
                  value={lead.refSourceMobile || ""}
                  onChange={(e) =>
                    setLead((prevState) => ({
                      ...prevState,
                      refSourceMobile: e.target.value,
                    }))
                  }
                />
              </>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        <div>
          <hr class="my-4 border border-dark w-100"></hr>
        </div>
        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Decision Maker:</label>
            <input
              type="text"
              placeholder="Name of the Decision Maker"
              className="form-control"
              value={lead.decisionMaker}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  decisionMaker: e.target.value,
                }))
              }
            />
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Mobile No:</label>
            <input
              type="text"
              placeholder="Contact of the Decision Maker"
              className="form-control"
              value={lead.dmMobile}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  dmMobile: e.target.value,
                }))
              }
            />
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Designation:</label>
            <input
              type="text"
              placeholder="Designation of the Decision Maker"
              className="form-control"
              value={lead.dmDesignation}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  dmDesignation: e.target.value,
                }))
              }
            />
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Email:</label>
            <input
              type="text"
              placeholder="Email of the Decision Maker"
              className="form-control"
              value={lead.dmEmail}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  dmEmail: e.target.value,
                }))
              }
            />
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Preferred Contact Timing:</label>
            <input
              type="time"
              className="form-control"
              value={lead.preferredContactTiming}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  preferredContactTiming: e.target.value,
                }))
              }
              step="60" // Allows selecting minutes
            />
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Next Follow Up date:</label>
            <DatePicker
              className="form-control"
              selected={lead.nextfollow}
              onChange={(date) => {
                // Check if date is not null
                if (date) {
                  // Set time part of the date to 11:00 AM IST
                  date.setHours(11);
                  date.setMinutes(0);
                  date.setSeconds(0);
                  date.setMilliseconds(0);
                }

                setLead((prevState) => ({
                  ...prevState,
                  nextfollow: date,
                }));
              }}
              placeholderText="Select Next Follow Up date"
              dateFormat="yyyy-MM-dd"
              required={true}
            />
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="form-group">
            <label>Assign To:</label>
            <select
              className="form-control"
              value={lead.telecaller}
              onChange={(e) =>
                setLead((prevState) => ({
                  ...prevState,
                  telecaller: e.target.value,
                }))
              }
            >
            <option value="Not assigned">Select Assignee</option>
                  {[...marketingExecutive, 
                  ...marketingManager, 
                  ...vendorManagementExecutive, 
                  ...vendorManagementManager, ...allEmployees].map(
                    (item, index) => (
                      <option key={index} value={item?.empId}>
                        {`${item?.fname} ${item?.mname} ${item?.lname}`}
                      </option>
                    )
                  )}
                </select>
          </div>
        </div>
      </div>

      <div className="row mx-1">
        <button
          className="btn btn-primary btn-block"
          type="submit"
          onClick={() => handleLead()}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default MarketingAddLead;
